import { FeaturedIcon, AppIcons } from '@backrs_ui/common-ui';

import { Box, SxProps, Theme, Typography } from '@mui/material';

interface OnboardingStepHeaderProps {
  iconName: AppIcons;
  title: string;
  subtitle?: string;
}

export const OnboardingStepHeader = ({ iconName, title, subtitle }: OnboardingStepHeaderProps) => (
  <Box sx={headerContainerStyle}>
    <FeaturedIcon iconName={iconName} size="xl" color="Colors/Foreground/fg-secondary" />
    <Box sx={titleContainerStyle}>
      <Typography variant="display-sm-semibold">{title}</Typography>
      {subtitle && (
        <Typography variant="text-md-regular" sx={subtitleSx}>
          {subtitle}
        </Typography>
      )}
    </Box>
  </Box>
);

const headerContainerStyle: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: backrs.spacing['spacing-4xl'],
  marginBottom: backrs.spacing['spacing-4xl'],
  textAlign: 'center',
});

const titleContainerStyle: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: backrs.spacing['spacing-lg'],
});

const subtitleSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
  maxWidth: '360px',
});
